/**
 * @file        env-capabilities.js
 *              Module to return information about the DCP host environment capabilities.
 *
 * @author      KC Erb
 * @date        Mar 2020
 */

Object.defineProperty(exports, 'hasNativeRequire', {
  get: function() {
    return eval('typeof require === "function"')
  }
})